(function() {
  let isChecking = false;
  let lastValues = {};

  function showLineItemError(lineKey, message) {
    let line = null;
    document.querySelectorAll('[id^="CartItem-"]').forEach(r => {
      if (r.querySelector(`input[data-index="${lineKey}"]`)) {
        line = r.id.replace('CartItem-', '');
      }
    });
    if (!line) return;
    const errorEl = document.getElementById(`Line-item-error-${line}`);
    if (errorEl) errorEl.querySelector('.cart-item__error-text').innerHTML = message;
  }

  function checkCollectionLimitFromDOM(lineKey, newQuantity, itemCollections) {
    if (!itemCollections) return { allowed: true };

    const collections = itemCollections.split(',').map(c => c.trim()).filter(Boolean);
    if (!collections.length) return { allowed: true };

    const isColorSample = collections.some(c => c.includes('color-sample'));

    let limit = 4;
    let groupKey = null;

    if (isColorSample) {
      groupKey = collections.find(c => c.includes('color-sample'));
    } else if (collections.includes('semi-custom-tiles')) {
      groupKey = 'semi-custom-tiles';
      limit = 10;
    } else if (collections.includes('designer-tiles')) {
      groupKey = 'designer-tiles';
    } else {
      groupKey = collections[0];
    }

    const colorSampleKey = `${groupKey}-color-sample`;

    let total = 0;
    document.querySelectorAll('[id^="CartItem-"]').forEach(row => {
      if (row.classList.contains('cart-item__nested-line')) return;
      const rowCollections = (row.dataset.collection || '').split(',').map(c => c.trim()).filter(Boolean);
      if (rowCollections.includes(colorSampleKey)) return;
      if (!rowCollections.includes(groupKey)) return;
      const qtyInput = row.querySelector('input[name="updates[]"]');
      const qty = (qtyInput && qtyInput.dataset.index === lineKey)
        ? newQuantity
        : (parseInt(qtyInput?.value) || 0);
      total += qty;
    });

    if (total > limit) {
      const language = document.documentElement.lang || 'en';
      const messages = {
        en: `The samples in this category are limited to ${limit} items.`,
        ja: `このカテゴリーのサンプルは${limit}点まで選択できます。`
      };
      return { allowed: false, message: messages[language] || messages.en };
    }

    return { allowed: true };
  }

  async function updateCartItem(lineKey, quantity, currentQty) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });

      if (!response.ok) {
        const message = (currentQty != null && window.cartStrings?.quantityError)
          ? window.cartStrings.quantityError.replace('[quantity]', currentQty)
          : (window.cartStrings?.error || 'Error');
        showLineItemError(lineKey, message);
        return;
      }

      const cart = await response.json();
      const updatedItem = cart.items.find(i => i.key === lineKey);
      const actualQty = updatedItem ? updatedItem.quantity : null;

      if (actualQty !== null && actualQty < quantity) {
        const message = window.cartStrings?.quantityError
          ? window.cartStrings.quantityError.replace('[quantity]', actualQty)
          : `Only ${actualQty} item(s) available in stock.`;
        showLineItemError(lineKey, message);
      } else {
        sessionStorage.setItem('cart-flash', '1');
        location.reload();
      }
    } catch (err) {
      console.error('[Cart Limits] Update error:', err);
    }
  }

  function disableShopifyAutoUpdate() {
    document.querySelectorAll('input[name="updates[]"]').forEach(input => {
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      const key = newInput.dataset.index;
      if (key) lastValues[key] = parseInt(newInput.value) || 0;
    });
  }

  document.addEventListener('change', async function(e) {
    const qtyInput = e.target.closest('input[name="updates[]"]');
    if (!qtyInput) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isChecking) return;

    const lineKey = qtyInput.dataset.index;
    const newQuantity = parseInt(qtyInput.value) || 0;
    const currentQuantity = lastValues[lineKey] || 0;

    if (newQuantity <= currentQuantity) {
      await updateCartItem(lineKey, newQuantity);
      return;
    }

    isChecking = true;

    try {
      const limitCheck = checkCollectionLimitFromDOM(lineKey, newQuantity, qtyInput.dataset.collection);
      if (!limitCheck.allowed) {
        showLineItemError(lineKey, limitCheck.message);
        qtyInput.value = currentQuantity;
        isChecking = false;
        return;
      }

      await updateCartItem(lineKey, newQuantity, currentQuantity);
    } catch (err) {
      console.error('[Cart Limits] Error:', err);
      qtyInput.value = currentQuantity;
    }

    isChecking = false;
  }, true);

  document.addEventListener('click', async function(e) {
    const button = e.target.closest('button[name="plus"], button[name="minus"]');
    if (!button) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isChecking) return;

    const qtyInput = button.closest('.quantity').querySelector('input[name="updates[]"]');
    if (!qtyInput) return;

    const lineKey = qtyInput.dataset.index;
    const currentQty = parseInt(qtyInput.value) || 0;
    const newQty = button.name === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

    if (newQty <= currentQty) {
      await updateCartItem(lineKey, newQty);
      return;
    }

    isChecking = true;

    try {
      const limitCheck = checkCollectionLimitFromDOM(lineKey, newQty, qtyInput.dataset.collection);
      if (!limitCheck.allowed) {
        showLineItemError(lineKey, limitCheck.message);
        isChecking = false;
        return;
      }

      await updateCartItem(lineKey, newQty, currentQty);
    } catch (err) {
      console.error('[Cart Limits] Error:', err);
    }

    isChecking = false;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(disableShopifyAutoUpdate, 100));
  } else {
    setTimeout(disableShopifyAutoUpdate, 100);
  }

  if (sessionStorage.getItem('cart-flash')) {
    sessionStorage.removeItem('cart-flash');
    document.addEventListener('DOMContentLoaded', () => {
      const visibleCircle = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (visibleCircle) {
        setTimeout(() => {
          visibleCircle.style.transition = 'background-color 0.3s ease';
          visibleCircle.style.backgroundColor = '#FFE7E7';
          setTimeout(() => { visibleCircle.style.backgroundColor = ''; }, 300);
        }, 100);
      }
    });
  }

})();
